import { Hero } from "./Components/Hero"
// import SecondLayer from "./Components/SecondLayer"
import Carousel from './Components/Carousel'
import Contact from "./Components/Contact"
import Aboutme from "./Components/Aboutme"
import Footer from "./Components/Footer"
import { BrowserRouter } from "react-router-dom"
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <>
        <Hero />
        <Aboutme />
        <Carousel />
        <Contact />
        <Footer />
      </>
    </BrowserRouter>
  )
}

export default App;
